import * as React from 'react';

import { Checkbox, Toolbar, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { CustomTableCellCheckBox, CustomTableCellDownload, CustomTableCellRimStatus, CustomTableCellText, CustomTableSentDateAndRefresh } from './material-ui-styles';

import { CommunicationOverviewHonoraryNoteItemForDisplay } from '../../../../store/details/overview/types';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { Paper, Table, TableBody, TableRow } from '@mui/material';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './overview.module.css';
import BelfiusCurrencyText from '../../../custom/belfius-currency-text';
import { BelfiusTooltip } from 'src/components/custom/belfius-tooltip';

interface Props {
  readonly title: string;
  readonly rows: CommunicationOverviewHonoraryNoteItemForDisplay[];
  readonly toggleItem: (id: number) => void;
  readonly togleAll?: (checked: boolean) => void;
  readonly toggleAllChecked: boolean;
  readonly currentLanguage: string;
  readonly caseBlocked: boolean;
}

type AllProps = Props;


export class OverviewTableHonoraryNote extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    return (
      <Paper>
        <Toolbar className={styles.toolbar}>
          <Typography variant='h5' id='tableTitle'>
            {this.props.title}
          </Typography>
        </Toolbar>
        <Table className={styles.table}>
          <TableBody>
            {this.props.rows.map(row => {
              return (
                <TableRow hover key={row.id()}>
                  <CustomTableCellCheckBox padding='checkbox'>
                    <Checkbox
                      disabled={!row.canDelete() || this.props.caseBlocked}
                      checked={row.selected()}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => { this.props.toggleItem(row.id()); }}
                    />
                  </CustomTableCellCheckBox>
                  <CustomTableCellText component='th' scope='row'>
                    {`${row.id()} (${this.localization.getFormatedDate(row.date(), this.props.currentLanguage)})`}
                  </CustomTableCellText>
                  <CustomTableCellRimStatus component='th' scope='row'>
                  <BelfiusCurrencyText
                      value={`${row.amount()}`}
                      prefix='€ ' />
                  </CustomTableCellRimStatus>
                  <CustomTableCellRimStatus />
                  <CustomTableCellDownload component='th' scope='row' />
                  <CustomTableCellDownload component='th' scope='row' />
                  <CustomTableSentDateAndRefresh scope='row'>
                    {this.localization.getFormatedDateTime(row.sentOn(), this.props.currentLanguage)}
                  </CustomTableSentDateAndRefresh>

                  <CustomTableCellCheckBox>
                    {row.needsApproval() ?
                    <BelfiusTooltip title={row.createdByName()}>
                      <div>
                        <CheckCircleOutlineIcon
                          aria-owns='simple-menu'
                          aria-haspopup='true'>check_circle_outline</CheckCircleOutlineIcon>
                      </div>
                  </BelfiusTooltip> : '' }
                  </CustomTableCellCheckBox>

                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}
